class FileUtils {
  downloadCsvFile(fileName: string, content: string): void {
    const element = document.createElement("a");
    element.href = `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURI(content)}`;
    element.download = fileName;
    element.click();
  }
}

const fileUtils = new FileUtils();
export default fileUtils;
